import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'lib-see-more-items-button',
  imports: [MatButtonModule],
  templateUrl: './see-more-items-button.component.html',
  styleUrl: './see-more-items-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeeMoreItemsButtonComponent {
  totalCount = input.required<number>();
  displayedCount = input.required<number>();
  showPaginationCount = input<boolean>(true);
  isLoading = input<boolean>(false);

  _displayedCount = computed(() =>
    this.displayedCount() > this.totalCount() ? this.totalCount() : this.displayedCount(),
  );

  loadMore = output<void>();
}
